import { valueStringFormat } from '../../../shared/utils/formatters';
import { ColumnLabel } from '../../../shared/models/ColumnLabel';
import OverlayTrigger from '@rio-cloud/rio-uikit/components/overlay/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/components/tooltip/Tooltip';
import { Link, useNavigation } from 'react-router';
import Spinner from '@rio-cloud/rio-uikit/components/spinner/Spinner';
import { createSearchParams } from '../../../shared/utils/utilsStrings';
import { IAnalysis } from '../models/Analysis';
import { datetimeFormatter } from '../../../shared/utils';
import { useDateFilterStore } from '../../../services/dateFilterStore';

type TableRowContentProps = {
  row: any;
  index: number;
  columns: string[];
  columnLabels: ColumnLabel;
  currentExtractLinkIndex: any;
  setCurrentExtractLinkIndex: any;
};

const TableRowContent = (props: TableRowContentProps) => {
  const { row, index, columns, columnLabels, currentExtractLinkIndex, setCurrentExtractLinkIndex} = props;
  const navigation = useNavigation();
  const { startDate, endDate } = useDateFilterStore();

  return (
    <tr className='compactRow'>
      {columns.map(col => {
        if (['itSpeed', 'itBraking', 'itCoasting', 'itKickdown', 'itAcceleration', 'itRpm', 'itClutch', 'itOperationalInsistence', 'itIdling', 'itIdlingAc', 'itAttentiveDriving', 'itRollover'].includes(col)) {
          return (
            <td key={col} data-field={columnLabels[col]} >
              <OverlayTrigger
                key={crypto.randomUUID()}
                overlay={
                  <Tooltip id='tooltip' allowOnTouch>
                    {row[col as keyof IAnalysis]} {row[col as keyof IAnalysis] > 1 ? 'Eventos' : 'Evento'}
                  </Tooltip>
                }
              >
                <div style={{ width: 100, fontSize: 11.2, justifyContent: 'center', flexDirection: 'column', alignItems: 'center', alignSelf: 'stretch', textTransform: 'capitalize' }} className={row[col as keyof any] == 0 ? 'label label-success' : 'label label-warning'}>{valueStringFormat(row[col as keyof any])} {row[col as keyof any] > 1 ? 'Eventos' : 'Evento'}</div>
              </OverlayTrigger>
            </td>
          );
        }

        if ('itGoodPractices' == col) {
          return (
            <td key={col} data-field={columnLabels[col]} >
              <OverlayTrigger
                key={crypto.randomUUID()}
                overlay={
                  <Tooltip id='tooltip' allowOnTouch>
                    {row[col as keyof IAnalysis]} {row[col as keyof IAnalysis] > 1 ? 'Eventos' : 'Evento'}
                  </Tooltip>
                }
              >
                <div style={{ width: 100, fontSize: 11.2, justifyContent: 'center', flexDirection: 'column', alignItems: 'center', alignSelf: 'stretch', textTransform: 'capitalize' }} className={row[col as keyof any] == 0 ? 'label label-warning' : 'label label-success'}>{valueStringFormat(row[col as keyof any])} {row[col as keyof any] > 1 ? 'Eventos' : 'Evento'}</div>
              </OverlayTrigger>
            </td>
          )
        }

        if ('epk' == col) {
          return (
            <td key={col} data-field={columnLabels[col]} >
              <div style={{ width: 70, fontSize: 11.2, justifyContent: 'center', padding: '2px 2px', flexDirection: 'column', alignItems: 'center', alignSelf: 'stretch', textTransform: 'capitalize' }} className={row[col as keyof any] == 0 ? 'label label-success' : 'label label-warning'}>{row[col as keyof any]}</div>
            </td>
          )
        }

        if ('tripCumulativeScore' == col) {
          return (
            < td className='text-size-14' key={col} data-field={columnLabels[col]} >
              {row[col as keyof IAnalysis]}
            </td>
          )
        }

        if ('extractLink' == col) {
          return (
            <td key={col} data-field={columnLabels[col]} >
              <span className='display-flex align-items-center gap-10' >
                {(navigation.state === 'loading' && currentExtractLinkIndex === index) && (
                  <div>
                    <Spinner />
                  </div>
                )}
                <Link
                  to={{ search: createSearchParams({ trip_id: row.tripId, behavior_type: row.behaviorType }) }}
                  onClick={() => {
                    setCurrentExtractLinkIndex(index)
                  }}>Acessar Extrato
                </Link>
              </span>
            </td>
          )
        }

        if ('startTrip' == col || 'finalTrip' == col) {
          return (
            <td className='text-size-14' key={col} data-field={columnLabels[col]}>
              <span>
                {datetimeFormatter.format(new Date(row[col as keyof IAnalysis]))}
              </span>
            </td>
          )
        }

        return (
          <td key={col} className='text-size-14' data-field={columnLabels[col]}>
            <span>{row[col as keyof IAnalysis]}</span>
          </td>
        );
      })}
    </tr>
  );
};

export default TableRowContent;